/**
 * TelemetryService — structured logging and metrics.
 *
 * This is the SSOT for all logging in the Share app.
 * Do NOT add Pino or other logging frameworks — extend this instead.
 */

export class TelemetryService {
  private static metricsMap = new Map<string, number>();

  public static incrementMetric(key: string, value: number = 1): void {
    const current = this.metricsMap.get(key) || 0;
    this.metricsMap.set(key, current + value);
  }

  public static getMetric(key: string): number {
    return this.metricsMap.get(key) || 0;
  }

  public static recordDuration(key: string, durationMs: number): void {
    this.metricsMap.set(`${key}_duration_ms`, durationMs);
  }

  public static logInfo(module: string, message: string): void {
    console.log(`[${new Date().toISOString()}] [INFO] [${module}] ${message}`);
  }

  public static logError(module: string, message: string, err?: unknown): void {
    const errMsg = err instanceof Error ? err.message : String(err ?? '');
    console.error(
      `[${new Date().toISOString()}] [ERROR] [${module}] ${message}`,
      errMsg
    );
  }

  public static logDebug(module: string, message: string): void {
    if (typeof __DEV__ !== 'undefined' && __DEV__) {
      console.log(
        `[${new Date().toISOString()}] [DEBUG] [${module}] ${message}`
      );
    }
  }

  /** Returns a function that, when called, records elapsed time */
  public static startTimer(key: string): () => void {
    const start = Date.now();
    return () => this.recordDuration(key, Date.now() - start);
  }
}

declare const __DEV__: boolean;
